
document.addEventListener("DOMContentLoaded", function () {
//herology hub landing page Chat box
    const btn = document.querySelector(
        ".hLanding-hub-section #card_chat-with-us a.hLanding-button"
    );

    if (!btn) return;

    // btn.addEventListener("click", function (e) {
    //     e.preventDefault();
    //     console.log('clicked');
    //     const interval = setInterval(() => {
    //     const host = document.querySelector('#shopify-chat inbox-online-store-chat');
    //     if (host?.shadowRoot) {
    //         const chatBtn = host.shadowRoot.querySelector('button.chat-toggle');
    //         document.getElementById("shopify-chat").style.display = "block";
    //         if (chatBtn) {
    //         console.log('yes');
    //         chatBtn.click();
    //         clearInterval(interval);
    //         }

    //     }
    //     }, 200); 

    //     const interval_ = setInterval(() => {
    //     const host = document.querySelector('#shopify-chat inbox-online-store-chat');
    //     if (host?.shadowRoot) {
            
    //         const closeBtns = host.shadowRoot.querySelectorAll(
    //         'button.chat-app--close-button, button[name="closeChat"]'
    //         );

    //         closeBtns.forEach((btn) => {
    //         if (!btn.dataset.bound) {
    //             btn.dataset.bound = "true";

    //             btn.addEventListener('click', function () {
    //             console.log('close clicked');

    //             const chat = document.getElementById("shopify-chat");
    //             if (chat) chat.style.display = "none";

    //             clearInterval(interval_);
    //             });
    //         }
    //         });
    //     }
    //     }, 200); 
        
    // }); 

});
